import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Tooltip,
  Warning as WarningIcon,
  Shop as ShopIcon
  // @ts-ignore
} from '@netbasequid/core'
import { useDisplayTheme, useSysTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import ChannelLevel, { ChannelLevelStrings } from 'enums/ChannelLevel'

interface ChannelLevelIconProps {
  level?: ChannelLevelStrings
}

const ChannelLevelIcon = ({ level }: ChannelLevelIconProps) => {
  const mode = useDisplayTheme() as Theme
  const theme = useSysTheme()
  const { t } = useTranslation()

  if (level === ChannelLevel.INSTAGRAM_INCIDENTAL_MATCH) {
    return (
      <Tooltip mode={mode} content={t('nonProfessionalInstagramAccount')}>
        <WarningIcon color={theme.semantic.negative.default} />
      </Tooltip>
    )
  }
  if (level === ChannelLevel.INSTAGRAM_BUSINESS) {
    return (
      <Tooltip mode={mode} content={t('instagramBusinessCreatorAccount')}>
        <ShopIcon color={theme.text.primary} />
      </Tooltip>
    )
  }
  return null
}

export default ChannelLevelIcon
